import { render, staticRenderFns } from "./AppHeaderMenuUserInfo.vue?vue&type=template&id=2f056360"
import script from "./AppHeaderMenuUserInfo.vue?vue&type=script&lang=js"
export * from "./AppHeaderMenuUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports